export default __webpack_public_path__ + "static/media/capsules.915a00a6.png";